import { render, staticRenderFns } from "./clientList.vue?vue&type=template&id=2edfdc97&scoped=true"
import script from "./clientList.vue?vue&type=script&lang=js"
export * from "./clientList.vue?vue&type=script&lang=js"
import style0 from "./clientList.vue?vue&type=style&index=0&id=2edfdc97&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edfdc97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edfdc97')) {
      api.createRecord('2edfdc97', component.options)
    } else {
      api.reload('2edfdc97', component.options)
    }
    module.hot.accept("./clientList.vue?vue&type=template&id=2edfdc97&scoped=true", function () {
      api.rerender('2edfdc97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/deviceAccess/clientList.vue"
export default component.exports